import * as React from "react";
import type { SVGProps } from "react";
const SvgAirplaneToLeftTop = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.13 20.82a2.64 2.64 0 0 0 1.87-.78l4-4a2.65 2.65 0 0 0-3.31-4.13l-.32.21-1.19-1.21 3.06-3a2.589 2.589 0 0 0 .79-1.9 2.68 2.68 0 0 0-.77-1.89 2.65 2.65 0 0 0-3.36-.32l-4.12 2.78-2.67-2.67A3 3 0 1 0 3.9 8.12l2.7 2.7-2.8 4.09a2.654 2.654 0 1 0 4.1 3.37l3-3.08 1.19 1.18-.21.32a2.648 2.648 0 0 0 2.21 4.12h.04Zm4-7.33a.65.65 0 0 1 .65.645.64.64 0 0 1-.19.455l-4 4a.65.65 0 0 1-1.1-.395.64.64 0 0 1 .11-.425l.66-1a1 1 0 0 0-.12-1.26l-2.48-2.47a1 1 0 0 0-1.41 0l-3.8 3.87a.65.65 0 0 1-1-.82l3.22-4.79a1 1 0 0 0-.12-1.26L5.29 6.71A1 1 0 1 1 6.7 5.3l3.28 3.27a1 1 0 0 0 1.26.12l4.8-3.23a.65.65 0 0 1 .8.08.631.631 0 0 1 0 .9l-3.78 3.81a1 1 0 0 0 0 1.41l2.48 2.48a1 1 0 0 0 1.26.12l1-.66a.59.59 0 0 1 .36-.11h-.03Z"
    />
  </svg>
);
export default SvgAirplaneToLeftTop;
